import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LogService } from '@medlogic/shared/shared-interfaces';

@Component({
  selector: 'ui-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css'],
})
export class DialogConfirmComponent implements OnInit {

  public options: any[]
  public inputText: string;
  public inputControl: FormControl = new FormControl();
  public label: string = 'Digite o texto';
  public pattern: string;
  public type: string = 'text';
  public placeholder: string = 'Digite o texto';
  public inputTitle: string = 'Digite o texto';
  public text: string;

  @ViewChild('inputDialogConfirm') input!: ElementRef<HTMLTextAreaElement>;

  private _title: string;
  public get title(): string {
    return this._title;
  }
  public set title(v: string) {
    this._title = v;
  }

  constructor(
    protected log: LogService,
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.options = data.options
    this.text = data.text;

    if (data.input) {
      const { value, label, type, pattern, placeholder, title } = data?.input;

      this.inputText = value;
      this.inputControl = new FormControl(this.inputText, [
        Validators.required,
        Validators.pattern(this.pattern)
      ]);
      this.label = label;
      this.type = type;
      this.pattern = pattern;
      this.placeholder = placeholder;
      this.inputTitle = title;

      setTimeout(() => {
        if (this.input) {
          this.input.nativeElement.focus();
        }
      }, 100);
    }
  }

  ngOnInit() { }

  /* Click em fechar. */
  onCloseClick(event?: any): void {
    try {
      this.dialogRef.close({ wasConfirmed: false });
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onCloseClick', error.message);
    }
  }

  /* Click em confirmar. */
  onConfirmClick(event?: any): void {
    try {
      if (this.inputControl.invalid) {
        this.inputControl.markAsTouched();
        return;
      }

      this.inputText = this.inputControl.value

      var checkedNumbers = [];
      var checkboxIds = this.options;

      for (var i = 0; i < checkboxIds?.length; i++) {
        var checkbox = document.getElementById(`${checkboxIds[i].name}-` + i);
        if (checkbox instanceof HTMLInputElement && checkbox.type === "checkbox") {
          if (checkbox.checked) {
            checkedNumbers.push(i);
          }
        }
      }

      this.dialogRef.close({ wasConfirmed: true, dialogSelecteds: checkedNumbers, input: { value: this.inputText } });
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onConfirmClick', error.message);
    }
  }

  /* Click em cancelar. */
  onCancelClick(event?: any): void {
    try {
      this.dialogRef.close({ wasConfirmed: false });
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onCancelClick', error.message);
    }
  }
}
